var map = {
	"./telia-accordion_2.entry.js": [
		2103,
		2103
	],
	"./telia-alert-badge.entry.js": [
		396,
		396
	],
	"./telia-badge_2.entry.js": [
		1494,
		1494
	],
	"./telia-banner-billboard.entry.js": [
		2690,
		2690
	],
	"./telia-breadcrumbs-item.entry.js": [
		5244,
		5244
	],
	"./telia-breadcrumbs.entry.js": [
		6598,
		6598
	],
	"./telia-button.entry.js": [
		6458,
		6458
	],
	"./telia-card-frame.entry.js": [
		3140,
		3140
	],
	"./telia-checkbox.entry.js": [
		7095,
		7095
	],
	"./telia-chip-choice.entry.js": [
		6742,
		6742
	],
	"./telia-chip-filter.entry.js": [
		9307,
		9307
	],
	"./telia-col_3.entry.js": [
		7756,
		7756
	],
	"./telia-color-dot.entry.js": [
		9613,
		9613
	],
	"./telia-content-banner.entry.js": [
		4500,
		4500
	],
	"./telia-counter-badge.entry.js": [
		506,
		506
	],
	"./telia-cta-link.entry.js": [
		4707,
		4707
	],
	"./telia-date-picker.entry.js": [
		8801,
		8801
	],
	"./telia-divider.entry.js": [
		7141,
		7141
	],
	"./telia-field-assistive-text_3.entry.js": [
		7930,
		7930
	],
	"./telia-field-valid.entry.js": [
		3215,
		3215
	],
	"./telia-fieldset.entry.js": [
		7634,
		7634
	],
	"./telia-focus-trap.entry.js": [
		6858,
		6858
	],
	"./telia-footer-legal.entry.js": [
		4169,
		4169
	],
	"./telia-footer-navigation.entry.js": [
		4088,
		4088
	],
	"./telia-footer-partners.entry.js": [
		9333,
		9333
	],
	"./telia-footer.entry.js": [
		4901,
		4901
	],
	"./telia-form.entry.js": [
		7688,
		7688
	],
	"./telia-heading.entry.js": [
		4094,
		4094
	],
	"./telia-hero-banner.entry.js": [
		921,
		921
	],
	"./telia-icon.entry.js": [
		39,
		39
	],
	"./telia-image.entry.js": [
		7405,
		7405
	],
	"./telia-link-image.entry.js": [
		1674,
		1674
	],
	"./telia-link_2.entry.js": [
		8355,
		8355
	],
	"./telia-list.entry.js": [
		7074,
		7074
	],
	"./telia-logo.entry.js": [
		5857,
		5857
	],
	"./telia-navigation-button.entry.js": [
		6865,
		6865
	],
	"./telia-navigation-dropdown.entry.js": [
		6652,
		6652
	],
	"./telia-navigation-link.entry.js": [
		1933,
		1933
	],
	"./telia-navigation.entry.js": [
		2396,
		2396
	],
	"./telia-notification.entry.js": [
		113,
		113
	],
	"./telia-overlay.entry.js": [
		9192,
		9192
	],
	"./telia-p.entry.js": [
		2960,
		2960
	],
	"./telia-pictogram.entry.js": [
		3066,
		3066
	],
	"./telia-price.entry.js": [
		5193,
		5193
	],
	"./telia-product-card-hardware.entry.js": [
		9775,
		9775
	],
	"./telia-radio-button.entry.js": [
		6924,
		6924
	],
	"./telia-search-input.entry.js": [
		2523,
		2523
	],
	"./telia-select.entry.js": [
		6026,
		6026
	],
	"./telia-skeleton.entry.js": [
		1913,
		1913
	],
	"./telia-slot-group.entry.js": [
		8848,
		8848
	],
	"./telia-status-badge.entry.js": [
		6082,
		6082
	],
	"./telia-style-navigation-item.entry.js": [
		6966,
		6966
	],
	"./telia-tab-content.entry.js": [
		1567,
		1567
	],
	"./telia-tab-header.entry.js": [
		9485,
		9485
	],
	"./telia-tab.entry.js": [
		3167,
		3167
	],
	"./telia-text-input.entry.js": [
		9584,
		9584
	],
	"./telia-text-spacing.entry.js": [
		6357,
		6357
	],
	"./telia-textarea.entry.js": [
		764,
		764
	],
	"./telia-toggle.entry.js": [
		1638,
		1638
	],
	"./telia-video-player.entry.js": [
		1769,
		1769
	],
	"./telia-visually-hidden.entry.js": [
		4022,
		4022
	],
	"./telia-voca-stats.entry.js": [
		8655,
		8655
	],
	"./telia-vst.entry.js": [
		1853,
		1853
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3057;
module.exports = webpackAsyncContext;